import { useCustomer } from '@studio/storeV2/customer/hooks/use-customer';

const useIsAIEnhanceEnabled = (): {
  aiEnhancementEnabled: boolean;
  aiVideosPerMonth: number;
} => {
  const { subscriptionDetails } = useCustomer();

  const aiVideosPerMonth = subscriptionDetails?.aiVideosPerMonth ?? 0;

  return { aiEnhancementEnabled: aiVideosPerMonth > 0, aiVideosPerMonth };
};

export default useIsAIEnhanceEnabled;
